import { render, staticRenderFns } from "./contactus-icon-box.vue?vue&type=template&id=725ce080&scoped=true"
import script from "./contactus-icon-box.vue?vue&type=script&lang=js"
export * from "./contactus-icon-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725ce080",
  null
  
)

export default component.exports